import { useParams, useSearchParams } from "react-router-dom";

export function useQueryParams() {
  const { project_id, upload_id } = useParams();
  const [sp] = useSearchParams();

  const category = sp.get("category") ?? null;
  const index = sp.get("index") ?? null;
  const value = sp.get("value") ?? null;

  return { project_id, upload_id, category, index, value };
}
